export const CREATE_PSEUDONYM_SUCCESS = 'CREATE_PSEUDONYM_SUCCESS';

export const createPseudonymSuccess = ({ pseudonym }) => ({
    type: CREATE_PSEUDONYM_SUCCESS,
    payload: {
        pseudonym,
    }
});
